import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {ButtonModule} from '@ucx/ui-cmp';
import {SurveyMergeModalComponent} from './survey-merge-modal.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
      SurveyMergeModalComponent,
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        ButtonModule,
        CommonModule
    ],
    providers: [],
    exports: [
      SurveyMergeModalComponent
    ]
})

export class SurveyMergeModalModule {
}
